import React from 'react';
import { connect } from 'react-redux';
import {
    updateItemInfo,
    updateItemDisplayInfo
} from '../../actions/items';
import style from './collapsible-section.scss';
import withRipple from "jd-library/withRipple";

const CollapsibleHeader = withRipple(props => {
    return (
        <div className={style['collapse-header'] + ' ' + props.rippleClass} onClick={props.clickHandler} {...props.rippleHandler}>
            <div className={style['collapse-label']}>
                {props.label}
            </div>
            <div className={style['right-icon']}>
                <i className='icon-pagination-down'></i>
            </div>
            {props.renderRipple()}
        </div>
    )
}
)

const CollapsibleSectionHOC = (ComponentToWrap, SectionLabel, wrapperClass) => {
    class CollapsibleSectionHOC extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                class: '',
                toggleClass: false,
                isCollapsed: false,
                currentHeight: 0,
                wrappedComponentStyle: { maxHeight: 0 },
                label: SectionLabel
            }
            this.sectionHeight = 0;
            this.toggleSection = this.toggleSection.bind(this);
            this.wrappedComponentRef = React.createRef();
        }
        componentDidMount() {
            if (this.wrappedComponentRef && this.wrappedComponentRef.current && this.wrappedComponentRef.current.clientHeight) {
                this.sectionHeight = this.wrappedComponentRef.current.clientHeight;
                this.setState({
                    wrappedComponentStyle: { maxHeight: 950 }
                });
            }
            let label = this.state.label;
            let toggleClass = this.state.toggleClass;
            if (label == 'Product Category & Prescription') {
                toggleClass = true;
                if (!this.props.permissions.isAutomatedCategorization && this.props.permissions.uploadPrescription) {
                    label = 'Product Category & Prescription';
                } else if (!this.props.permissions.isAutomatedCategorization && !this.props.permissions.uploadPrescription) {
                    label = 'Product Category';
                } else if (this.props.permissions.isAutomatedCategorization && this.props.permissions.uploadPrescription) {
                    label = 'Medical Prescription';
                }
            } else if (label == 'Product Name, Category & Description') {
                toggleClass = true;
                if (this.props.permissions.isAutomatedCategorization) {
                    label = 'Product Name & Description';
                }
            }
            this.setState({ label: label, toggleClass: toggleClass });
        }
        toggleSection() {
            if (this.state.isCollapsed) {
                if (this.state.toggleClass) {
                    this.setState({ class: "" });
                }
                this.setState({ wrappedComponentStyle: { maxHeight: 0 } });
                setTimeout(() => {
                    this.setState({ isCollapsed: false })
                }, 900);
            }
            else {
                this.setState({ isCollapsed: true }, () => {
                    setTimeout(() => {
                        this.setState({ wrappedComponentStyle: { maxHeight: 950 } });
                    }, 10);
                    setTimeout(() => {
                        if (this.state.toggleClass) {
                            this.setState({ class: "overflow-unset" });
                        }
                    }, 500);
                });
            }
        }
        render() {
            let collapsibleSec = <div className={`${style['collapsible-div']} ${this.state.isCollapsed ? 'collapsed' : ''} ${(this.state.label == 'Product Category & Prescription' || this.state.label == 'Medical Prescription') ? 'border-upward' : ''}`}>
                <CollapsibleHeader clickHandler={this.toggleSection} label={this.state.label} />
                {this.state.isCollapsed &&
                    <div ref={this.wrappedComponentRef} style={this.state.wrappedComponentStyle} className={`${style['wrapped-component']} ${this.state.class} ${wrapperClass}`}>
                        <ComponentToWrap {...this.props} />
                    </div>
                }
            </div>;
            if (!this.props.itemInfo.isEdit) {
                if (this.props.showCollapsibleWrapper) {
                    return (collapsibleSec)
                } else {
                    return (<ComponentToWrap {...this.props} />)
                }
            }
            if (this.props.noCollapse) {
                return (<ComponentToWrap {...this.props} />)
            }
            return (collapsibleSec)
        }
    }
    const mapStateToProps = state => {
        return {
            session: state.session,
            permissions: state.permissions,
            deviceData: state.deviceData,
            itemInfo: state.items.itemInfo,
            errors: state.items.errors
        };
    };
    return connect(mapStateToProps, {
        updateItemInfo,
        updateItemDisplayInfo
    })(CollapsibleSectionHOC);
}


export default CollapsibleSectionHOC;